import { Loader } from '@googlemaps/js-api-loader';

class GoogleMapsService {
  private static instance: GoogleMapsService;
  private loader: Loader | null = null;
  private isLoaded: boolean = false;
  private loadPromise: Promise<void> | null = null;

  private constructor() {}

  public static getInstance(): GoogleMapsService {
    if (!GoogleMapsService.instance) {
      GoogleMapsService.instance = new GoogleMapsService();
    }
    return GoogleMapsService.instance;
  }

  public async loadGoogleMaps(): Promise<void> {
    // If already loaded, return immediately
    if (this.isLoaded) {
      return Promise.resolve();
    }

    // If loading is in progress, return the existing promise
    if (this.loadPromise) {
      return this.loadPromise;
    }

    // Check for API key
    if (!process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
      throw new Error('Google Maps API key not found. Please add REACT_APP_GOOGLE_MAPS_API_KEY to your environment variables.');
    }

    // Create the load promise
    this.loadPromise = this.initializeLoader();
    return this.loadPromise;
  }

  private async initializeLoader(): Promise<void> {
    try {
      if (!this.loader) {
        this.loader = new Loader({
          apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY!,
          version: 'weekly',
          libraries: ['places', 'marker'] // Geocoder is part of core Maps API, no need to load separately
        });
      }

      await this.loader.load();
      this.isLoaded = true;
    } catch (error) {
      console.error('❌ Error loading Google Maps:', error);
      this.loadPromise = null; // Reset promise so we can retry
      throw error;
    }
  }

  public isGoogleMapsLoaded(): boolean {
    return this.isLoaded;
  }
}

export default GoogleMapsService;
